import { observer } from 'mobx-react'
import React, { useState } from 'react'

import { UserPIN as UserPINComponent } from '@flowwai-frontend/shared-web/iam/ui'

import { UserPIN } from '@flowwai-frontend/shared-web/iam/data-access'
import UserPINUpdateModal from '../../components/UserPINUpdateModal/UserPINUpdateModal'

interface Props {
   userPIN: UserPIN | null
   setUserPIN: (userPIN: UserPIN) => void
}

const UserPINController = (props: Props): React.ReactElement => {
   const { userPIN, setUserPIN } = props

   const [isModalOpen, setIsModalOpen] = useState(false)

   const onResetPIN = () => {
      setIsModalOpen(true)
   }

   const onCloseModal = () => {
      setIsModalOpen(false)
   }

   return (
      <React.Fragment>
         <UserPINComponent
            isPINConfigured={!!userPIN?.isPINConfigured}
            generatedOn={userPIN?.generatedOn}
            expiresOn={userPIN?.expiresOn}
            onResetPIN={onResetPIN}
            containerClassName='p-4 border border-gray-300'
         />

         <UserPINUpdateModal
            userPIN={userPIN}
            setUserPIN={setUserPIN}
            isModalOpen={isModalOpen}
            onCloseModal={onCloseModal}
         />
      </React.Fragment>
   )
}

export default observer(UserPINController)
